import styled from 'styled-components'
export const StyledErrorBlock = styled.div`
  display: flex;
  align-items: flex-end;
  font-size: 13px;
  color: ${props => props?.isWarning ? props.theme.main.colors.warningColor : props.theme.main.colors.errorColor};
  width: 100%;
  margin-bottom: 24px;
`
